<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :ecomCompanyCode="params.code"
      />
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-base-salesCompany-detail',
  components: {
    EditForm,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {},
}
</script>
